import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'lyceo-card',
  standalone: true,
  template: `<ng-content />`,
  styleUrls: ['./card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardComponent {}
